import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const EligibilityHeroSection = () => {
  return (
    <div className="emi-hero-section" style={{ height: 'fit-content', marginBottom: '0px' }}>
      <Container style={{ height: 'fit-content' }}>
        <Row className="justify-content-center align-items-center">
          <Col md={12} className="text-center">
            <p className="hero-title" style={{ fontSize: '26px', margin: '1.5rem auto' }}>
            Following details will help us find the best available offer for you!
            </p>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default EligibilityHeroSection;
